var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleBreastEndocrineSurgery from '../../schemas/module-breast-endocrine-surgery.json';
var SchemaModuleBreastEndocrineSurgery = (function (_super) {
    __extends(SchemaModuleBreastEndocrineSurgery, _super);
    function SchemaModuleBreastEndocrineSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleBreastEndocrineSurgery);
        return _this;
    }
    return SchemaModuleBreastEndocrineSurgery;
}(SchemaModuleUniversal));
export { SchemaModuleBreastEndocrineSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-breast-endocrine-surgery.ts.pre-build-optimizer.js